const baseOrder = {
  'baseOrder.orderStatus': 'Статус заказа',
  'baseOrder.orderStatus.placeholder': 'Выберите статус заказа',
  'baseOrder.orderStatus.toBeConfirmed': 'На подтверждении',
  'baseOrder.orderStatus.confirmed': 'Подтверждён',
  'baseOrder.orderStatus.toBeShipped': 'Ожидает отгрузки',
  'baseOrder.orderStatus.partiallyShipped': 'Частично отправлено',
  'baseOrder.orderStatus.completed': 'Завершён',
  'baseOrder.orderStatus.cancelled': 'Отменён',

  'baseOrder.shipmentStatus': 'Статус доставки',
  'baseOrder.shipmentStatus.placeholder': 'Выберите статус доставки',
  'baseOrder.shipmentStatus.notShipped': 'Не отправлено',
  'baseOrder.shipmentStatus.partiallyShipped': 'Частично отправлено',
  'baseOrder.shipmentStatus.shipped': 'Отправлено',
  'baseOrder.shipmentStatus.abnormalShipping': 'Аномальная доставка',

  'baseOrder.paymentStatus': 'Статус оплаты',
  'baseOrder.paymentStatus.placeholder': 'Выберите статус оплаты',
  'baseOrder.paymentStatus.unpaid': 'Не оплачено',
  'baseOrder.paymentStatus.partiallyPaid': 'Частично оплачено',
  'baseOrder.paymentStatus.paid': 'Оплачено',
  'baseOrder.paymentStatus.paymentException': 'Ошибка оплаты',

  'baseOrder.orderNumber': 'Номер заказа',
  'baseOrder.orderNumber.placeholder': 'Введите номер заказа',
  'baseOrder.orderTime': 'Время заказа',

  'baseOrder.customerName': 'Имя клиента',
  'baseOrder.skuTotal': 'Всего SKU',
  'baseOrder.totalAmount': 'Сумма товаров',
  'baseOrder.fee': 'Расходы',
};

export default baseOrder;
